// WebSocket URL configuration service

export const getWebSocketUrl = (endpoint) => {
  const baseUrl = process.env.REACT_APP_WS_URL || process.env.REACT_APP_API_URL || 'ws://localhost:8000';
  const protocol = baseUrl.startsWith('https') ? 'wss' : 'ws';
  
  // Extract host from API URL if WS URL is not set
  if (!process.env.REACT_APP_WS_URL) {
    const apiUrl = new URL(process.env.REACT_APP_API_URL || 'http://localhost:8000');
    return `${protocol}://${apiUrl.host}${endpoint}`;
  }
  
  // If WS URL is set, use it directly
  if (baseUrl.startsWith('ws://') || baseUrl.startsWith('wss://')) {
    return `${baseUrl}${endpoint}`;
  }
  
  // Otherwise, construct from base URL
  return `${protocol}://${baseUrl.replace(/^https?:\/\//, '')}${endpoint}`;
};

export const getClipboardWebSocketUrl = () => {
  return getWebSocketUrl('/api/clipboard/ws');
};

export const getOTCWebSocketUrl = () => {
  return getWebSocketUrl('/otc/ws');
};

export const getCentrifugoWebSocketUrl = () => {
  // Default Centrifugo WS endpoint
  return process.env.REACT_APP_CENTRIFUGO_WS_URL || 'ws://localhost:9000/connection/websocket';
};
